<template lang='pug'>
  .fpui-input-radios(:class="theme")
    .fpui-input-radio(:class='{ disabled: opt.disabled }', v-for="opt in optionsValues")
      input.checkbox(
        :disabled='opt.disabled',
        :id="opt.id",
        type="radio",
        :value="opt.value",
        v-model="model"
      )
      label(:for="opt.id") {{opt.label | translate}}
</template>

<script>

export default {
  props: {
    value: { required: true },
    options: {
      required: true,
      type: Array,
      default () {
        return []
      }
    },
    theme: { type: String, default: 'v3' }
  },
  data () {
    return {
      optionsValues: []
    }
  },
  created () {
    this.optionsValues = this.options.map((opt) => {
      opt.id = '_' + Math.random().toString(36).substr(2, 9) + opt.value
      return opt
    })
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";
@import "~@/shared/styles/theme_v4/_variables.less";

// theme_v3
@fpui-input-radio-size: 20px;
@fpui-input-radio-checked-color:@blue;
@fpui-input-radio-checked-size: 12px;
@fpui-input-radio-border-color:@blue;
@fpui-input-radio-border-color-disabled: @grey;

.fpui-input-radios.v3 {
    margin: 16px 0;
    .fpui-input-radio {
        display: inline-block;
        &.disabled {
            label {
                cursor: not-allowed;
                &:before {
                    border: 2px solid @fpui-input-radio-border-color-disabled;
                }
            }
        }
    }
    input[type="radio"] {
        display: none;
        &:checked + label:before {
            border-color: @fpui-input-radio-checked-color;
            animation: ripple 0.2s linear forwards;
        }
        &:checked + label:after {
            transform: scale(1);
        }
    }
    label {
        display: inline-block;
        height:@fpui-input-radio-size;
        line-height: @fpui-input-radio-size;
        position: relative;
        font-weight: 200;
        padding: 0 (@fpui-input-radio-size + 10px);
        margin-bottom: 0;
        cursor: pointer;
        vertical-align: bottom;
        &:before, &:after {
            position: absolute;
            content: '';
            border-radius: 50%;
            transition: all .3s ease;
            transition-property: transform, border-color;
        }
        &:before {
            left: 0;
            top: 0;
            width: @fpui-input-radio-size;
            height: @fpui-input-radio-size;
            border: 2px solid @fpui-input-radio-border-color;
        }
        &:after {
            top: @fpui-input-radio-size / 2 - @fpui-input-radio-checked-size / 2;
            left: @fpui-input-radio-size / 2 - @fpui-input-radio-checked-size / 2;
            width:@fpui-input-radio-checked-size;
            height:@fpui-input-radio-checked-size;
            transform: scale(0);
            background:@fpui-input-radio-checked-color;
        }
    }
}

// theme_v4
@fpui-input-radio-size_v4: 15px;
@fpui-input-radio-checked-color_v4: @blue_v4;
@fpui-input-radio-checked-border-color_v4: @blue_flash;
@fpui-input-radio-checked-size_v4: 11px;
@fpui-input-radio-border-color_v4: @grey-middle_v4;
@fpui-input-radio-border-color-disabled_v4: @grey-middle_v4;

.fpui-input-radios.v4 {
    margin: 16px 0;
    .fpui-input-radio {
        display: inline-block;
        &.disabled {
            label {
                color: @grey-middle_v4;
                cursor: not-allowed;
                &:before {
                    border: 1px solid @fpui-input-radio-border-color-disabled_v4;
                }
            }
        }
    }
    input[type="radio"] {
        display: none;
        &:checked + label:before {
            border-color: @fpui-input-radio-checked-border-color_v4;
            animation: ripple 0.2s linear forwards;
        }
        &:checked + label:after {
            transform: scale(1);
        }
    }
    label {
        display: inline-block;
        height:@fpui-input-radio-size_v4;
        line-height: @fpui-input-radio-size_v4;
        position: relative;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        padding: 0 (@fpui-input-radio-size_v4 + 10px);
        margin-bottom: 0;
        cursor: pointer;
        vertical-align: bottom;
        &:before, &:after {
            position: absolute;
            content: '';
            border-radius: 50%;
            transition: all .3s ease;
            transition-property: transform, border-color;
        }
        &:before {
            left: 0;
            top: 0;
            width: @fpui-input-radio-size_v4;
            height: @fpui-input-radio-size_v4;
            border: 1px solid @fpui-input-radio-border-color_v4;
        }
        &:after {
        //     top: @fpui-input-radio-size_v4 / 1 - @fpui-input-radio-checked-size_v4 / 1;
        //     left: @fpui-input-radio-size_v4 / 1 - @fpui-input-radio-checked-size_v4 / 1;
            top: 2px;
            left: 2px;
            width:@fpui-input-radio-checked-size_v4;
            height:@fpui-input-radio-checked-size_v4;
            transform: scale(0);
            background:@fpui-input-radio-checked-color_v4;
            // border: 1px solid @fpui-input-radio-checked-border-color_v4;
        }
    }
}

</style>
